import phoneImg from "../assets/Frame 422.png"; // Replace with your tilted phone mockup
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

function WhatThisAppDoes() {
  return (
    <section className="py-5 what-app-does-bg">
      <div className="container ">
        <div className="row align-items-center">
          {/* Text column: shows first on mobile, second on desktop */}
          <div className="col-lg-5 order-1 px-4 px-lg-5 order-lg-2">
            <h2 className="fw-bold">What This App Does</h2>
            <p className="text-muted mb-4">
              This citizen-powered app helps you:
            </p>

            {/* Feature Grid */}
            <div className="row g-3 mb-4">
              <div className="col-6">
                <div className="feature-card  report-civic-bg text-white p-3 rounded-4 h-100">
                  <h2 className="fw-bold ">1</h2>
                  <p className="mb-0  ">
                    Report civic and emergency issues in your environment
                  </p>
                </div>
              </div>

              <div className="col-6">
                <div className="feature-card send-sos-bg text-white p-3 rounded-4 h-100">
                  <h2 className="fw-bold text-10 ">2</h2>
                  <p className="mb-0">
                    Send SOS alerts in real-time when you need help
                  </p>
                </div>
              </div>

              <div className="col-6">
                <div className="feature-card earn-rewards-bg text-white p-3 rounded-4 h-100">
                  <h2 className="fw-bold">3</h2>
                  <p className="mb-0">
                    Earn rewards for verified, approved reports
                  </p>
                </div>
              </div>

              <div className="col-6">
                <div className="feature-card redeem-rewards-bg text-white p-3 rounded-4 h-100">
                  <h2 className="fw-bold">5</h2>
                  <p className="mb-0">
                    Redeem rewards as coupons or withdraw directly to your bank
                  </p>
                </div>
              </div>
            </div>

            {/* Store Buttons */}
            <div className="d-flex gap-2">
              <a href="https://play.google.com/">
                <img src={googleImg} alt="Google Play" height="40" />
              </a>
              <a href="https://play.google.com/">
                <img src={appStoreImg} alt="App Store" height="40" />
              </a>
            </div>
          </div>

          {/* Image column: shows second on mobile, first on desktop */}
          <div className="col-lg-6 order-2 order-lg-1 text-center mt-4 mt-lg-0">
            <img
              src={phoneImg}
              alt="CivicX phone preview"
              className="img-fluid"
              style={{ maxWidth: "85%", transform: "rotate(-5deg)" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatThisAppDoes;
